import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const GiftCardIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path
      fillRule="evenodd"
      d="M15.96 8.54a2.697 2.697 0 0 0-3.813 0L12 8.687l-.147-.147a2.696 2.696 0 0 0-3.813 3.814l3.96 3.96 3.96-3.96a2.697 2.697 0 0 0 0-3.814ZM13.207 9.6a1.196 1.196 0 1 1 1.692 1.693L12 14.192l-2.9-2.9a1.196 1.196 0 1 1 1.693-1.69l1.208 1.204L13.207 9.6Z M2.002 19.996v-16h20v16h-20Zm1.5-14.5h17v13h-17v-13Z"
    />
  </IconWrapper>
)

export default GiftCardIconMedium
